import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "../../Catalyst/table";
import { SupportDebugBill } from "../../../services/SupportDebugService";
import { EM_DASH, formatCurrency, formatDate } from "./utils";

interface BillsTableProps {
  bills: SupportDebugBill[];
  emptyMessage: string;
}

// Shared recurring-bills table — same columns everywhere bills are shown
// (upcoming bills panel, safe-to-spend lists, cashflow paid/remaining lists).
const BillsTable = ({ bills, emptyMessage }: BillsTableProps) => {
  if (bills.length === 0) {
    return (
      <div className="flex items-center justify-center px-6 py-10">
        <p className="text-sm font-medium text-texthead opacity-70">{emptyMessage}</p>
      </div>
    );
  }

  return (
    <div className="px-6 pb-4">
      <Table>
        <TableHead>
          <TableRow>
            <TableHeader>Merchant / Description</TableHeader>
            <TableHeader>Category</TableHeader>
            <TableHeader className="text-right">Amount</TableHeader>
            <TableHeader className="text-right">Monthly amount</TableHeader>
            <TableHeader>Frequency</TableHeader>
            <TableHeader>Next bill date</TableHeader>
            <TableHeader>Last bill date</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          {bills.map((bill) => (
            <TableRow key={bill.id}>
              <TableCell>
                <div className="font-medium text-texthead">
                  {bill.merchantName || bill.description || EM_DASH}
                </div>
                {bill.merchantName && bill.description && (
                  <div className="text-xs text-textColor">{bill.description}</div>
                )}
              </TableCell>
              <TableCell className="text-textColor3">
                {bill.finleyCategoryName || bill.finleyCategory || bill.categoryType || EM_DASH}
              </TableCell>
              <TableCell className="text-right tabular-nums">{formatCurrency(bill.amount)}</TableCell>
              <TableCell className="text-right tabular-nums">
                {formatCurrency(bill.monthlyAmount)}
              </TableCell>
              <TableCell className="text-textColor3">{bill.frequency || EM_DASH}</TableCell>
              <TableCell>{formatDate(bill.nextBillDate)}</TableCell>
              <TableCell>{formatDate(bill.lastBillDate)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default BillsTable;
